import { Navigate } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import Error404Page from 'app/pages/404/Error404Page';

import AuthPage from 'app/pages/Auth/AuthConfig';
import PatientsPage from 'app/pages/Patients/PatientsConfig';
import PatientsHelpPage from 'app/pages/PatientHelp/PatientsHelpConfig';
import PharmaciesPage from 'app/pages/Pharmacies/PharmaciesConfig';
import ProActivatedPage from 'app/pages/ProActivated/ProActivatedConfig';
import AnnouncementsPage from 'app/pages/Announcements/AnnouncementsConfig';
import MarketingPage from 'app/pages/Marketing/MarketingConfig';
import MarketingCampaignsPage from 'app/pages/MarketingCampaigns/MarketingCampaigns';
import HealtheraProPage from 'app/pages/HealtheraPro/HealtheraProConfig';
import PrescribingPage from 'app/pages/Prescribing/PrescribingConfig';
import CanadaServicesPage from 'app/pages/Services/canada/ServicesConfig';
import SupportGroupServicesPage from 'app/pages/Services/canada/SupportGroupServicesConfig';
import TmpBroadcastingPage from 'app/pages/TmpBroadcasting/canada/TmpBroadcastingConfig';
import CanadaBroadcastsPage from 'app/pages/MarketingCampaigns/canada/BroadcastsConfig';
import ServicesPage from 'app/pages/Services/ServicesConfig';
import QuestionnairesPage from 'app/pages/Questionnaires/QuestionnairesConfig';
import DashboardPage from 'app/pages/ServiceDashboard/DashboardConfig';
import AnalyticsDashboardPage from 'app/pages/Dashboard/DashboardConfig';
import ManagedRepeatsPage from 'app/pages/ManagedRepeats/ManagedRepeatsConfig';
import LiteBranchUpgradePage from 'app/pages/LiteBranchUpgrade/LiteBranchUpgradeConfig';
import OrdersPage from 'app/pages/Orders/OrdersConfig';
import OrdersV2Page from 'app/pages/OrdersV2/OrdersConfig';
import RequestsPage from 'app/pages/Requests/RequestsConfig';
import CalendarPage from 'app/pages/Calendar/CalendarConfig';
import AppointmentsPage from 'app/pages/Appointments/AppointmentsConfig';
import MasterServicesPage from 'app/pages/MasterServices/MasterServicesConfig';
import ProductsPage from 'app/pages/Products/ProductsConfig';
import PgdPage from 'app/pages/Pgd/PgdConfig';
import PgdManagePage from 'app/pages/PgdManage/PgdManageConfig';
import SmsCampaignsPage from 'app/pages/SmsCampaigns/SmsCampaignsConfig';
import SmsCampaignRegisterInterestConfig from 'app/pages/SmsCampaigns/SmsCampaignsConfig';
import SuperLinksPage from 'app/pages/SuperLinks/SuperLinksConfig';
import InAppBannersConfig from 'app/pages/InAppBanners/InAppBannersConfig';
import MarketingMaterialPage from 'app/pages/MarketingMaterial/MarketingMaterialConfig';
import MtiUploaderConfig from 'app/pages/MtiUploader/MtiUploaderConfig';
import TrainingAndGuidesPage from 'app/pages/TrainingAndGuides/TrainingAndGuidesConfig';
import PlusWebsitesPage from 'app/pages/PlusWebsites/PlusWebsitesConfig';
import BillingAndReportsPage from 'app/pages/BillingAndReports/BillingAndReportsConfig';
import CommandCentrePage from 'app/pages/CommandCentre/CommandCentreConfig';
import SupportDashboardPage from 'app/pages/Support/SupportDashboardConfig';
import RxManagementPage from 'app/pages/RxManagement/RxManagementConfig';
import UsersPage from 'app/pages/Users/UsersConfig';
import GuidesPage from 'app/pages/Guides/GuidesConfig';
import { HomePageComponent } from 'app/hooks/useHomePage';
import { authRoles } from 'app/auth';
import config from '../../config.json';

const ukRouteConfigs = [
  CommandCentrePage,
  AuthPage,
  PatientsPage,
  PatientsHelpPage,
  AnnouncementsPage,
  MarketingPage,
  MarketingCampaignsPage,
  ProActivatedPage,
  HealtheraProPage,
  ServicesPage,
  DashboardPage,
  AnalyticsDashboardPage,
  ManagedRepeatsPage,
  LiteBranchUpgradePage,
  OrdersPage,
  PrescribingPage,
  PharmaciesPage,
  MasterServicesPage,
  ProductsPage,
  PgdPage,
  PgdManagePage,
  QuestionnairesPage,
  CalendarPage,
  AppointmentsPage,
  SmsCampaignsPage,
  SmsCampaignRegisterInterestConfig,
  SuperLinksPage,
  InAppBannersConfig,
  MarketingMaterialPage,
  TrainingAndGuidesPage,
  PlusWebsitesPage,
  BillingAndReportsPage,
  RxManagementPage,
  UsersPage,
  GuidesPage,
];

const canadaRouteConfigs = [
  AuthPage,
  PatientsPage,
  PharmaciesPage,
  RequestsPage,
  OrdersV2Page,
  CanadaServicesPage,
  SupportGroupServicesPage,
  CalendarPage,
  AppointmentsPage,
  TmpBroadcastingPage,
  CanadaBroadcastsPage,
  MasterServicesPage,
  SmsCampaignsPage,
  SuperLinksPage,
  MtiUploaderConfig,
  PlusWebsitesPage,
  SupportDashboardPage,
  UsersPage,
];

// TODO: Temp solution: Only allow [LoginPage, PatientsPage, PharmaciesPage] deployment region is Canada
const routeConfigs = config.deploymentRegion === 'canada' ? canadaRouteConfigs : ukRouteConfigs;

// if you want to make whole app auth protected by default change defaultAuth for example:
// ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin','staff','user']),
// The individual route configs which has auth option won't be overridden.
const defaultAuth = authRoles.pharmacist;
const routes = FuseUtils.generateRoutesFromConfigs(routeConfigs, defaultAuth);

export const allRoutes = [
  ...routes,
  {
    path: '/',
    element: <HomePageComponent />,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: '*',
    element: <Navigate to="404" />,
  },
];

export default allRoutes;
